// Der EINE Leerzustand.
//
// WOFUER: ersetzt die im Audit gefundenen 7 verschiedenen Leerzustands-Bauarten
// (es gab keine geteilte Komponente). Das gestrichelte Muster war im Bestand
// vereinzelt vorhanden und wurde im Audit als "gut, behalten" bewertet — es
// wird hier zur Regel.

import type { JSX, ComponentChildren } from "preact";
import type { LucideIcon } from "lucide-preact";

export interface EmptyStateProps {
  /** lucide-Icon, keine Emojis. */
  icon?: LucideIcon;
  title: string;
  description?: string;
  /** Rechts unten nichts — die Aktion sitzt zentriert unter dem Text. */
  action?: ComponentChildren;
  class?: string;
}

export function EmptyState(props: EmptyStateProps): JSX.Element {
  const { icon: Icon, title, description, action, class: klass } = props;
  return (
    <div
      class={`flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-[color:var(--color-outline-variant)] px-6 py-12 text-center${
        klass ? ` ${klass}` : ""
      }`}
    >
      {Icon && (
        <Icon
          size={24}
          aria-hidden="true"
          class="text-[color:var(--color-on-surface-variant)] opacity-70"
        />
      )}
      <p class="text-sm font-medium text-[color:var(--color-on-surface)]">{title}</p>
      {description && (
        <p class="max-w-[42ch] text-xs text-[color:var(--color-on-surface-variant)]">
          {description}
        </p>
      )}
      {action && <div class="mt-1 flex items-center gap-2">{action}</div>}
    </div>
  );
}
